export default __webpack_public_path__ + "static/media/32.4b4fa643.jpg";